import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "absolute -left-[9999px] top-0 h-0 w-0 overflow-hidden",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 0,
  class: "text-red-600 w-full justify-center text-sm font-bold pb-4 items-end flex dark:text-red-500"
}
const _hoisted_3 = { class: "pt-4" }

import {
		ref
	} from 'vue'

	
	const __default__ = { name: 'InvoiceLookupForm' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
		loading: {
			type: Boolean,
			default: false
		},
		message: {
			type: String,
			default: ''
		}
	},
  emits: [
		'submit'
	],
  setup(__props, { emit: __emit }) {

	// vue
	

	const emit = __emit

	const invoiceNumber = ref("")
	const accountNumber = ref("")
	const honeypot = ref("")

	// hands the entered values to the page, which owns the lookup itself
	function submitLookup() {
		if (accountNumber.value == "") {
			document.getElementById('accountNumber')?.focus()
			return
		}

		if (invoiceNumber.value == "") {
			document.getElementById('invoiceNumber')?.focus()
			return
		}

		emit('submit', {
			invoiceNumber: invoiceNumber.value,
			accountNumber: accountNumber.value,
			honeypot: honeypot.value
		})
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (submitLookup()), ["prevent"])),
    class: "space-y-6"
  }, [
    _createVNode(_component_tw_input, {
      modelValue: accountNumber.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountNumber).value = $event)),
      id: "accountNumber",
      name: "accountNumber",
      required: true,
      type: "text",
      autocomplete: "off",
      label: "Account Number",
      placeholder: "12345",
      validation: "Please enter your account number."
    }, null, 8, ["modelValue"]),
    _createVNode(_component_tw_input, {
      modelValue: invoiceNumber.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((invoiceNumber).value = $event)),
      id: "invoiceNumber",
      name: "invoiceNumber",
      required: true,
      type: "text",
      autocomplete: "off",
      label: "Invoice Number",
      placeholder: "67890",
      validation: "Please enter your invoice number."
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("label", {
        for: "website",
        class: "sr-only"
      }, "Leave this field blank", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((honeypot).value = $event)),
        type: "text",
        id: "website",
        name: "website",
        tabindex: "-1",
        autocomplete: "off"
      }, null, 512), [
        [_vModelText, honeypot.value]
      ])
    ]),
    _createElementVNode("div", null, [
      (__props.message)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.message), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_tw_button, {
          type: "submit",
          class: "btn-db-yellow w-full",
          disabled: __props.loading,
          loading: __props.loading
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode(" Find Invoice ")
          ])),
          _: 1,
          __: [5]
        }, 8, ["disabled", "loading"])
      ])
    ])
  ], 32))
}
}

})